<template>
  <v-content>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <template v-if="user.role === 'admin'">
            <v-card>
              <v-toolbar dense dark color="deep-orange" elevation="2">
                <v-toolbar-title>Resumen de actividades</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-title>Periodo: {{ periodo }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-row>
                  <v-col cols="6">
                    <div>
                      <apexchart type="bar" height="400" :options="chart.options" :series="chart.options.series"></apexchart>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <v-data-table :headers="headers" :items="items" :loading="loading"
                    :footer-props="{ 'items-per-page-text': 'Elementos por página' }" :items-per-page="5" item-key="id" class="elevation-1">
                      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                      <template v-slot:footer.page-text="props">
                        Página {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
                      </template>
                      <template v-slot:no-data>
                        No hay información disponible
                      </template>
                      <template v-slot:no-results>
                        No se obtuvieron resultados
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </template>
          <template v-else>
            En construcción...
          </template>
        </v-col>
      </v-row>
      <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
        {{ msgError }}
      </v-snackbar>
      <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
        {{ msgSuccess }}
      </v-snackbar>
    </v-container>
  </v-content>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import services from '@/utils/services'
import VueApexCharts from 'vue-apexcharts'

Vue.component('apexchart', VueApexCharts)

export default {
  name: 'home',
  data: () => ({
    loading: false,
    error: false,
    msgError: '',
    success: false,
    msgSuccess: '',
    chart: {
      options: {
        chart: {
          type: 'bar',
          id: 'resumen_actividades'
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: [
            ""
          ]
        },
        series: []
      }
    },
    periodo: null,
    headers: [
      { text: 'Encuesta', align: 'center', sortable: false, value: 'encuesta' },
      { text: 'Act. Actuales', align: 'center', sortable: false, value: 'act_actuales' },
      { text: 'Act. Próximas', align: 'center', sortable: false, value: 'act_proximas' }
    ],
    items: []
  }),
  mounted() {
    this.refresh()
  },
  computed: {
    ...mapGetters('general', [
      'user'
    ])
  },
  methods: {
    refresh() {
      if (this.user.role === 'admin') {
        this.loading = true
        services.ws('get', 'dashboard')
          .then(res => {
            if (res.ok) {
              this.periodo = res.data.periodo
              this.chart.options.series.push({
                name: 'Actuales',
                data: [res.data.act_actuales]
              })
              this.chart.options.series.push({
                name: 'Próximas',
                data: [res.data.act_proximas]
              })
              let encuestas = {}
              if (res.data.det_actuales) {
                for (let i = 0; i < res.data.det_actuales.length; i++) {
                  encuestas[res.data.det_actuales[i].encuesta] = {
                    act_actuales: res.data.det_actuales[i].act_actuales,
                    act_proximas: 0
                  }
                }
              }
              if (res.data.det_proximas) {
                for (let i = 0; i < res.data.det_proximas.length; i++) {
                  if (res.data.det_proximas[i].encuesta in encuestas) {
                    encuestas[res.data.det_proximas[i].encuesta].act_proximas = res.data.det_proximas[i].act_proximas
                  }
                  else {
                    encuestas[res.data.det_proximas[i].encuesta] = {
                      act_actuales: 0,
                      act_proximas: res.data.det_proximas[i].act_proximas,
                    }
                  }
                }
              }
              for (let key in encuestas) {
                this.items.push({
                  encuesta: key,
                  act_actuales: encuestas[key].act_actuales,
                  act_proximas: encuestas[key].act_proximas
                })
              }
            }
            else {
              this.error = true
              this.msgError = res.message
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
